import { CaptionStyles, CaptionLineConfig, HighlightTypeEnum } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const neo: Partial<CaptionStyles> = {
  theme_preset: 'neo',
  pageStyle: {
    color: '#7ffa32',
    textShadow: '-2px -1px 20px #07f82c'
  },
  wordStyle: {
    highlightType: HighlightTypeEnum.None,
    inactive: {
      color: '#7ffa32'
    }
  },
  font_location: getFontFullPath('SpaceMono-Bold.ttf'),
  caps: true,
  line_config: CaptionLineConfig.OneWord,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default neo;
